import InstagramPostsService from "./InstagramPostsService";

export default InstagramPostsService;
